<div class="anomaly__item" [ngStyle]="backgroundStyle" (click)="ShowVehicles()">
  <span class="anomaly__item--title">{{anomaly || 'En ruta'}}:</span>
  <span class="anomaly__item--value">{{amount}}</span>
</div>